const MonocleIcon = /*#__PURE__*/ [
  ["circle", { cx: "8", cy: "8", r: "6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "16", cy: "8", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 17V19C22 19.3506 21.9398 19.6872 21.8293 20M20 21.8293C19.6872 21.9398 19.3506 22 19 22C18.6494 22 18.3128 21.9398 18 21.8293M16 17V19C16 19.3506 16.0602 19.6872 16.1707 20M22 8V5M22 14V11M16 14V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { MonocleIcon as default };
//# sourceMappingURL=MonocleIcon.js.map
